var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 123,
    viewBox: "0 0 208 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0909 111.441C36.2522 116.12 27.0156 86.6163 -1.45454 90.2302C-29.9247 93.8441 -51.875 111.441 -71 132.059V139H694V39C679.656 70.797 659.336 125.991 624.455 130.57C589.573 135.148 584.031 70.797 554.909 57.9207C525.787 45.0445 514.703 100.352 485.364 102.894C456.024 105.437 441.789 75.6279 415.818 72.9811C389.847 70.3342 376.047 94.8575 346.273 90.4935C316.499 86.1295 305.523 49.3887 276.727 41.3567C247.931 33.3247 236.195 69.218 207.182 70.797C178.168 72.376 162.086 45.4099 137.636 49.3887C113.187 53.3676 99.9297 106.762 68.0909 111.441Z",
    fill: "url(#paint0_linear_14_3328)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-71 132.059C-51.875 111.441 -29.9247 93.8441 -1.45455 90.2302C27.0156 86.6163 36.2521 116.12 68.0909 111.441C99.9297 106.762 113.187 53.3676 137.636 49.3887C162.086 45.4099 178.168 72.376 207.182 70.797C236.195 69.218 247.931 33.3247 276.727 41.3567C305.523 49.3887 316.499 86.1295 346.273 90.4935C376.047 94.8575 389.847 70.3342 415.818 72.9811C441.789 75.6279 456.024 105.437 485.364 102.894C514.703 100.352 525.787 45.0445 554.909 57.9207C584.031 70.797 589.573 135.148 624.454 130.57C659.336 125.991 679.656 70.797 694 39",
    stroke: "#37D881",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M142 95.6298C169.614 95.6298 192 74.2224 192 47.8149C192 21.4075 169.614 0 142 0C114.386 0 92 21.4075 92 47.8149C92 74.2224 114.386 95.6298 142 95.6298Z",
    fill: "url(#paint1_radial_14_3328)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_3328",
    x1: 311.793,
    y1: 38.9999,
    x2: 311.71,
    y2: 216.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37D881",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452192,
    stopColor: "#37D881",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949877,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14_3328",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.899 50.8769) scale(50.154 48.1781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2FED7",
    stopOpacity: 0.9801
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A4FABF",
    stopOpacity: 0.6084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#88F7A9",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#70F497",
    stopOpacity: 0.1936
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5CF187",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#4BEF7A",
    stopOpacity: 0.0361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#3EEE70",
    stopOpacity: 0.0121
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#35EC69",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#30EC65",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FEC64",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line-chart.dc5786f33bd87e23d2871d16638600dc.svg";
export { ForwardRef as ReactComponent };